import { render, staticRenderFns } from "./kl_radar_chart.vue?vue&type=template&id=74810d9d&scoped=true"
import script from "./kl_radar_chart.vue?vue&type=script&lang=js"
export * from "./kl_radar_chart.vue?vue&type=script&lang=js"
import style0 from "./kl_radar_chart.vue?vue&type=style&index=0&id=74810d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74810d9d",
  null
  
)

export default component.exports